"use client"

import IconFont from "@repo/ui/iconfont"
import { useSigninModal } from "@repo/ui/signin"
import { useCallback } from "react"

import Style from "../index.module.scss"
import { useFavoriteContext } from "./SpotPriceTableShell"

interface FavoriteButtonProps {
	productId: string
	initialIsFav: boolean
	isLoggedIn: boolean
}

/**
 * 收藏按钮：使用 Favorite 上下文，切换时调用接口并更新状态
 */
export default function FavoriteButton({ productId, initialIsFav, isLoggedIn }: FavoriteButtonProps) {
	const { favoriteMap, toggleFavorite } = useFavoriteContext()
	const { showSignInModal } = useSigninModal()
	const isFav = favoriteMap[productId] ?? initialIsFav

	const handleClick = useCallback(() => {
		if (!isLoggedIn) {
			showSignInModal({
				action: "login",
				animate: "modal",
				onLoginSuccess: () => {
					window.location.reload()
				},
				onRegisterSuccess: () => {
					window.location.reload()
				},
			})
			return
		}
		void toggleFavorite(productId)
	}, [productId, toggleFavorite, isLoggedIn])

	return (
		<button
			type="button"
			className={Style.favBtn}
			onClick={handleClick}
			aria-label={isFav ? "Remove from watchlist" : "Add to watchlist"}
		>
			<IconFont
				type={isFav ? "icon-yishoucang" : "icon-weishoucangda"}
				className={isFav ? Style.favOn : Style.favOff}
			/>
		</button>
	)
}
